import { Banknote, ChevronRight, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { InstallButton } from '@/components/PwaInstall';

export function MasPage() {
  const role = useAuthStore((state) => state.user?.rol);
  const canReadLiquidation = role === 'admin' || role === 'ganadero' || role === 'veterinario';
  return (
    <main className="ui-page">
      <h1 className="ui-page-title mb-4">Opciones</h1>
      {canReadLiquidation && (
        <Link to="/liquidacion" className="ui-menu-row">
          <Banknote size={22} aria-hidden />
          <span>Liquidación</span>
          <ChevronRight size={18} aria-hidden />
        </Link>
      )}
      <Link to="/ajustes" className="ui-menu-row">
        <Settings size={22} aria-hidden />
        <span>Ajustes</span>
        <ChevronRight size={18} aria-hidden />
      </Link>
      <InstallButton menu />
    </main>
  );
}
